<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content">
      <h2>会员权益</h2>
      <div style="display: flex">
        <p
          style="
            width: 50px;
            font-size: 16px;
            color: #333;
            text-align: right;
            margin-right: 26px;
          "
        >
          赠品
        </p>
        <el-switch v-model="gift"></el-switch>
      </div>
      <div class="infobox" v-if="gift">
        <div class="infobox-content">
          <div class="info-item">
            <p class="item-title" style="margin-right: 6px">
              <span style="color: red">*</span>赠品说明
            </p>
            <el-input
              type="textarea"
              maxlength="100"
              v-model="giveawayText"
              resize="none"
              placeholder="请输入赠品说明"
              show-word-limit
              class="inputarea"
            ></el-input>
          </div>
          <div class="info-item" style="margin-top: 20px">
            <p class="item-title"><span style="color: red">*</span>选择赠品</p>
            <div style="width: 100%">
              <el-button type="primary" @click="selectGoods"
                >选择商品</el-button
              >
              <div
                style="
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <div style="width: 45%">
                  <div
                    class="goods-item"
                    v-for="(item, index) in allList"
                    :key="item.id"
                    v-if="index % 2 == 0"
                  >
                    <div class="number-dot">{{ index + 1 }}</div>
                    <p class="goods-title">{{ item.name }}</p>
                    <input-number
                      :num="item.num"
                      :max="item.stock"
                      @input="getGoodsCount($event, index)"
                    ></input-number>
                    <span class="del" @click="delGoods(index)">删除</span>
                  </div>
                </div>
                <div style="width: 45%">
                  <div
                    class="goods-item"
                    v-for="(item, index) in allList"
                    :key="item.id"
                    v-if="index % 2 != 0"
                  >
                    <div class="number-dot">{{ index + 1 }}</div>
                    <p class="goods-title">{{ item.name }}</p>
                    <input-number
                      :num="item.num"
                      :max="item.stock"
                      @input="getGoodsCount($event, index)"
                    ></input-number>
                    <span class="del" @click="delGoods(index)">删除</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="display: flex; margin-top: 24px">
        <p
          style="
            width: 50px;
            font-size: 16px;
            color: #333;
            text-align: right;
            margin-right: 26px;
          "
        >
          优惠券
        </p>
        <el-switch v-model="coupon"></el-switch>
      </div>
      <div class="infobox" v-if="coupon">
        <div class="infobox-content">
          <div class="info-item">
            <p class="item-title" style="margin-right: 6px">
              <span style="color: red">*</span>优惠券说明
            </p>
            <el-input
              type="textarea"
              maxlength="100"
              v-model="couponText"
              resize="none"
              placeholder="请输入优惠券说明"
              show-word-limit
              class="inputarea"
            ></el-input>
          </div>
          <div class="info-item" style="margin-top: 20px">
            <p class="item-title">
              <span style="color: red">*</span>选择优惠券
            </p>
            <div style="width: 100%">
              <el-button type="primary" @click="selectCoupon"
                >选择优惠券</el-button
              >
              <div
                style="
                  width: 100%;
                  display: flex;
                  justify-content: space-between;
                "
              >
                <div style="width: 45%">
                  <div
                    class="goods-item"
                    v-for="(item, index) in allCouponList"
                    :key="item.id"
                    v-if="index % 2 == 0"
                  >
                    <div class="number-dot">{{ index + 1 }}</div>
                    <p class="goods-title">{{ item.name }}</p>
                    <input-number
                      :num="item.num"
                      @input="getCouponCount($event, index)"
                    ></input-number>
                    <span class="del" @click="delCoupon(index)">删除</span>
                  </div>
                </div>
                <div style="width: 45%">
                  <div
                    class="goods-item"
                    v-for="(item, index) in allCouponList"
                    :key="item.id"
                    v-if="index % 2 != 0"
                  >
                    <div class="number-dot">{{ index + 1 }}</div>
                    <p class="goods-title">{{ item.name }}</p>
                    <input-number
                      :num="item.num"
                      @input="getCouponCount($event, index)"
                    ></input-number>
                    <span class="del" @click="delCoupon(index)">删除</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style="height: 20px"></div>
    </div>
    <div class="content bottom-but" v-if="gift || coupon">
      <el-button type="warning" @click="toBack">返回</el-button>
      <el-button type="primary" @click="submitFn">确认</el-button>
      <div style="height: 20px"></div>
    </div>

    <el-dialog
      title="选择商品"
      :append-to-body="true"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="815"
    >
      <div style="height: 600px; overflow-y: auto">
        <div class="search-box">
          <el-input
            placeholder="请输入商品名称/商品编号"
            size="mini"
            style="width: 224px; margin-right: 20px"
            v-model="goodsName"
          ></el-input>
          <el-button type="primary" @click="searchD" size="mini" plain
            >查询</el-button
          >
        </div>
        <el-table
          :data="goodsList"
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :show-header="false"
          border
        >
          <el-table-column type="selection" width="60"></el-table-column>
          <el-table-column prop="goodsName" label="">
            <template slot-scope="scope">
              <div style="display: flex">
                <img
                  :src="scope.row.image"
                  style="width: 72px; height: 56px; margin-right: 12px"
                  alt=""
                />
                <div
                  style="
                    font-size: 14px;
                    height: 56px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                  "
                >
                  <p style="color: #333333">{{ scope.row.name }}</p>
                  <p style="color: #999999">
                    商品编号：{{ scope.row.goodsNo }}
                  </p>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            height: 42px;
          "
        >
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
            :current-page="pageNo"
            :page-sizes="[5, 10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          >
          </el-pagination>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmFn">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="选择优惠券"
      :append-to-body="true"
      :visible.sync="couponDialog"
      :close-on-click-modal="false"
      width="815"
    >
      <div style="height: 600px; overflow-y: auto">
        <div class="search-box">
          <el-input
            placeholder="请输入优惠券名称"
            size="mini"
            style="width: 224px; margin-right: 20px"
            v-model="couponName"
          ></el-input>
          <el-button type="primary" @click="searchC" size="mini" plain
            >查询</el-button
          >
        </div>
        <el-table
          :data="couponList"
          ref="couponTable"
          @selection-change="handleCouponSelectionChange"
          :show-header="false"
          border
        >
          <el-table-column type="selection" width="60"></el-table-column>
          <el-table-column prop="name" label="">
            <!-- <template slot-scope="scope">
                            <div style="display: flex;">
                                <img :src="scope.row.image" style="width: 72px;height: 56px;margin-right: 12px;" alt="">
                                <div
                                    style="font-size: 14px;height: 56px;display: flex;flex-direction: column;justify-content: space-between;">
                                    <p style="color:#333333;">{{ scope.row.name }}</p>
                                    <p style="color: #999999;">商品编号：{{ scope.row.goodsNo }}</p>
                                </div>
                            </div>
                        </template> -->
          </el-table-column>
        </el-table>
        <div
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            height: 42px;
          "
        >
          <el-pagination
            @size-change="handleSizeChangeCou"
            @current-change="handleCurrentChangeCou"
            background
            :current-page="couponPageNo"
            :page-sizes="[5, 10, 20, 30]"
            :page-size="couponPageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="couponTotalNum"
          >
          </el-pagination>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="couponDialog = false">取 消</el-button>
        <el-button type="primary" @click="confirmCouponFn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import inputNumber from './components/inputNumber.vue'
export default {
  components: {
    breadcrumbTop,
    inputNumber
  },
  data () {
    return {
      dataList: {
        list: [
          { title: '矩阵管理', path: '', type: '0' },
          { title: '平台列表', path: '', type: '0' },
          { title: '会员权益', path: '', type: '1' }
        ]
      },
      gift: false,
      coupon: false,
      couponText: '',
      giveawayText: '',
      dialogVisible: false,
      goodsList: [],
      allList: [],
      selectList: [],
      platformId: null,
      vipId: null,
      goodsName: '',
      totalNum: 0,
      pageSize: 10,
      pageNo: 1,
      couponName: '',
      couponPageNo: 1,
      couponPageSize: 10,
      couponDialog: false,
      couponList: [],
      couponTotalNum: 0,
      conponSelectList: [],
      allCouponList: []
    }
  },
  created () {
    this.platformId = this.$route.query.platformId || null;
    this.vipId = this.$route.query.id || null;
    this.giveawayPageList()
    this.getCouponList()
    this.getInfo()
  },
  methods: {
    delGoods (idx) {
      console.log(idx)
      this.allList.splice(idx, 1)
      console.log(this.allList)
    },
    delCoupon (idx) {
      this.allCouponList.splice(idx, 1)
    },
    getInfo () {
      this.axios.get('/ps/psMembers/info?id=' + this.vipId)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.giveawayText = res.data.giveawayText;
            this.couponText = res.data.couponText;
            this.gift = res.data.giveawaySwitch == 1 ? true : false;
            this.coupon = res.data.couponSwitch == 1 ? true : false;
            let arr = res.data.interestGoods.map(item => {
              return {
                id: item.relationId,
                name: item.name,
                num: item.num
              }
            })
            this.allList = arr;

            let arr1 = res.data.interestCoupon.map(item => {
              return {
                id: item.relationId,
                name: item.name,
                num: item.num
              }
            })
            this.allCouponList = arr1;
          }
        })
    },
    submitFn () {
      let goodsList = [], couponList = [];
      if (this.gift) {
        if (this.giveawayText == '') {
          this.$message.warning('请输入赠品说明')
          return
        }
        if (this.allList.length == 0) {
          this.$message.warning('请选择赠品')
          return
        }
        goodsList = this.allList.map(item => {
          return {
            id: item.id,
            name: item.name,
            num: item.num
          }
        })
      }
      if (this.coupon) {
        if (this.couponText == '') {
          this.$message.warning('请输入优惠券说明')
          return
        }
        if (this.allCouponList.length == 0) {
          this.$message.warning('请选择优惠券')
          return
        }
        couponList = this.allCouponList.map(item => {
          return {
            id: item.id,
            name: item.name,
            num: item.num
          }
        })
      }
      let data = {
        id: this.vipId,
        giveawayText: this.giveawayText,
        couponText: this.couponText,
        goodsList: goodsList,
        couponList: couponList,
        giveawaySwitch: this.gift ? 1 : 0,
        couponSwitch: this.coupon ? 1 : 0
      }
      this.axios.post('/ps/psMembers/addEditInterest', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.$message.success('保存成功')
            this.toBack()
          } else {
            this.$message.warning(res.message)
          }
        })
    },
    confirmCouponFn () {
      this.allCouponList = this.allCouponList.concat(this.conponSelectList)
      this.allCouponList = this.removeDuplicateObj(this.allCouponList)
      this.allCouponList.forEach(item => {
        if (!item.num) {
          item.num = 1;
        }
      })
      this.couponDialog = false;
      console.log(this.allCouponList)
    },
    confirmFn () {
      this.allList = this.allList.concat(this.selectList)
      this.allList = this.removeDuplicateObj(this.allList)
      this.allList.forEach(item => {
        if (!item.num) {
          item.num = 1;
        }
      })
      this.dialogVisible = false;
      console.log(this.allList)
    },
    handleCurrentChangeCou (e) {
      this.couponPageNo = e;
      this.getCouponList()
    },
    handleSizeChangeCou (e) {
      this.couponPageSize = e;
      this.couponPageNo = 1;
      this.getCouponList()
    },
    handleCurrentChange (e) {
      this.pageNo = e;
      this.giveawayPageList()
    },
    handleSizeChange (e) {
      this.pageSize = e;
      this.pageNo = 1;
      this.giveawayPageList()
    },
    searchD () {
      this.pageNo = 1
      this.giveawayPageList(1)
    },
    searchC () {
      this.couponPageNo = 1
      this.getCouponList()
    },
    giveawayPageList (type) {
      let data = {
        name: this.goodsName,
        platformId: this.platformId,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.axios.post('/goods/goods/giveawayPageList', data)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.goodsList = res.data.list;
            this.totalNum = res.data.totalNum;
            if (type == 1) {
              // this.selectGoods()
            }
            this.$nextTick(() => {
              let list = []
              //遍历表格的数据，再遍历需要在表格中反显的数据，两者的id一致
              this.goodsList.forEach((item) => {
                this.allList.forEach(val => {
                  if (val.id == item.id) {
                    // 把判断出来的默认表格数据push到创建的数组中
                    list.push(item)
                  }
                })
              })
              // console.log(this.$refs.multipleTable)
              if (list) {
                //再遍历数组，将数据放入方法中
                list.forEach((row) => {
                  this.$refs.multipleTable.toggleRowSelection(row, true)
                })
              }
            })
          }
        })
    },
    getCouponList () {
      let data = {
        name: this.couponName,
        platformId: this.$route.query.platformId,
        status: 1,
        pageNo: this.couponPageNo,
        pageSize: this.couponPageSize
      }
      this.axios.post('/ps/psCoupon/getPageList', data)
        .then(res => {
          console.log(res)
          this.couponList = res.data.list;
          this.couponTotalNum = res.data.totalNum;
          this.$nextTick(() => {
            let list = []
            //遍历表格的数据，再遍历需要在表格中反显的数据，两者的id一致
            this.couponList.forEach((item) => {
              this.allCouponList.forEach(val => {
                if (val.id == item.id) {
                  // 把判断出来的默认表格数据push到创建的数组中
                  list.push(item)
                }
              })
            })
            // console.log(this.$refs.multipleTable)
            console.log(list)
            if (list) {
              //再遍历数组，将数据放入方法中
              list.forEach((row) => {
                this.$refs.couponTable.toggleRowSelection(row, true)
              })
            }
          })
        })
    },
    //对象数组去重
    removeDuplicateObj (arr) {
      let newArr = []
      let obj = {};
      for (var i = 0; i < arr.length; i++) {
        if (!obj[arr[i].id]) {
          newArr.push(arr[i]);
          obj[arr[i].id] = true;
        }
      }
      return newArr
    },
    handleCouponSelectionChange (e) {
      this.conponSelectList = e;
    },
    handleSelectionChange (e) {
      this.selectList = e;
    },
    selectCoupon () {
      this.couponDialog = true;
      this.couponName = ''
      this.getCouponList()
      // this.$nextTick(() => {
      //   let list = []
      //   //遍历表格的数据，再遍历需要在表格中反显的数据，两者的id一致
      //   this.couponList.forEach((item) => {
      //     this.allCouponList.forEach(val => {
      //       if (val.id == item.id) {
      //         // 把判断出来的默认表格数据push到创建的数组中
      //         list.push(item)
      //       }
      //     })
      //   })
      //   // console.log(this.$refs.multipleTable)
      //   console.log(list)
      //   if (list) {
      //     //再遍历数组，将数据放入方法中
      //     list.forEach((row) => {
      //       this.$refs.couponTable.toggleRowSelection(row, true)
      //     })
      //   }
      // })
    },
    selectGoods () {
      this.dialogVisible = true;
      this.goodsName = ''
      this.giveawayPageList()


      // this.$nextTick(() => {
      //   let list = []
      //   //遍历表格的数据，再遍历需要在表格中反显的数据，两者的id一致
      //   this.goodsList.forEach((item) => {
      //     this.allList.forEach(val => {
      //       if (val.id == item.id) {
      //         // 把判断出来的默认表格数据push到创建的数组中
      //         list.push(item)
      //       }
      //     })
      //   })
      //   // console.log(this.$refs.multipleTable)
      //   if (list) {
      //     //再遍历数组，将数据放入方法中
      //     list.forEach((row) => {
      //       this.$refs.multipleTable.toggleRowSelection(row, true)
      //     })
      //   }
      // })

    },
    toBack () {
      history.go(-1)
    },
    getGoodsCount (e, idx) {
      console.log(e, idx)
      this.allList[idx].num = e;
    },
    getCouponCount (e, idx) {
      console.log(e, idx)
      this.allCouponList[idx].num = e;
    }
  }
}
</script>
<style scoped lang="scss">
.infobox {
  width: 100%;
  padding-bottom: 16px;
  padding-left: 80px;
  box-sizing: border-box;
  border-bottom: 1px dashed #ededed;

  .infobox-content {
    width: 100%;
    padding: 16px 12px;
    box-sizing: border-box;
    background: #f1f6ff;
    margin-top: 22px;
    .info-item {
      width: 80%;
      display: flex;
      .item-title {
        font-size: 14px;
        color: #333333;
        margin-right: 12px;
        width: 84px;
      }
      ::v-deep .el-textarea {
        width: 466px;
      }
      .inputarea ::v-deep .el-textarea__inner {
        width: 466px;
        height: 96px;
      }
    }
    .goods-item {
      display: flex;
      width: 100%;
      // justify-content: space-between;
      font-size: 16px;
      color: #333333;
      margin-top: 15px;
      .number-dot {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        background-color: #4168e7;
        margin-right: 12px;
        font-size: 12px;
        color: white;
        text-align: center;
        margin-top: 2px;
      }
      .goods-title {
        width: 300px;
        margin-right: 30px;
      }
      .del {
        font-size: 14px;
        color: #f33f3f;
        cursor: pointer;
        margin-left: 38px;
      }
    }
  }
}
.bottom-but {
  margin-top: -20px;
  //   text-align: center;

  .el-button {
    width: 220px;
    height: 48px;
    border-radius: 4px;
    font-size: 18px;
  }

  .el-button + .el-button {
    margin-left: 32px;
  }
}
.search-box {
  width: 100%;
  height: 50px;
  background: #f8f8f8;
  padding: 0 16px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  border: 1px solid #e8eaec;
  border-bottom: 0;
}
</style>